// DEPENDENCIES
import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { useFormik } from "formik";
// COMPONENTS
import MUIDataTable from "mui-datatables";
import { Link } from 'react-router-dom';
import SVG from "react-inlinesvg";
import { Button, Modal } from "react-bootstrap";
// CUSTOM COMPONENTS
import * as alert from "../../../../redux/alertSnackBarRedux";
import * as confirmModal from "../../../../redux/confirmModalRedux";
// SERVICES AND HELPERS
import * as reportEmailService from "../../../../services/management/reportEmailService";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import ReportEmailValidator from "../../../../helpers/validators/ReportEmailValidator";
import { getInputClasses } from "../../../../helpers/helper";

const AutomatedReportEmailListingPage = (props) => {
    const { showAlert, showConfirmModal, hideConfirmModal, reportName, reportId } = props;
    var initialEmail = {
        id: 0,
        reportTypeId: reportId,
        email: ''
    }

    const [data, setData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedEmail, setSelectedEmail] = useState(initialEmail);

    useEffect(() => {
        loadTableData();
    }, [])

    const loadTableData = () => {
        reportEmailService.getReportEmails(reportId).then(res => {
            setData(res);
        }).catch((ex) => {
            showAlert({ message: ex.message, variant: "error" });
        });
    }

    const editEmail = (id) => {
        reportEmailService.getReportEmailById(id).then(res => {
            setSelectedEmail(res);
            setIsModalOpen(true);
        })
    }

    const deleteEmail = (id) => {
        reportEmailService.deleteReportEmail(id).then(res => {
            showAlert({ message: res.message, variant: "success" });
            loadTableData();
            hideConfirmModal();
        })
    }

    const columns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                width: 1,
                download: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            <button
                                className="btn btn-sm btn-info font-weight-bold py-2 px-3 px-xxl-5"
                                onClick={() => editEmail(data[dataIndex].id)}
                            >
                                Edit
                        </button> &nbsp;
                            <button
                                onClick={() => showConfirmModal({
                                    title: "Delete Email",
                                    text: "Are you sure you want to delete this email?",
                                    rightBtnText: "Confirm",
                                    btnAction: () => deleteEmail(data[dataIndex].id)
                                })}
                                className="btn btn-sm btn-danger font-weight-bold py-2 px-3 px-xxl-5 my-1"
                            >
                                Delete
                        </button>
                        </>
                    );
                }
            },

        },
        {
            name: "email",
            label: "Email",
            options: {
                filter: true,
                sort: true,
            }
        }
    ];

    const handleModalClose = () => {
        setIsModalOpen(false);
        setSelectedEmail(initialEmail);
        formik.resetForm();
    }

    const saveEmail = (values, setStatus, setSubmitting) => {
        reportEmailService.saveReportEmail(values).then(res => {
            showAlert({ message: res.message, variant: "success" });
            loadTableData();
            handleModalClose();
        }).catch((ex) => {
            showAlert({ message: ex.message, variant: "error" });
        })
    }


    const formik = useFormik({
        enableReinitialize: true,
        initialValues: selectedEmail,
        validationSchema: ReportEmailValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            saveEmail(values, setStatus, setSubmitting);
        }
    });

    return (
        <div className="row" >
            <Modal centered size="lg" show={isModalOpen} onHide={handleModalClose}>
                <form className="card card-custom" onSubmit={formik.handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>Email</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form">
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Email
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <div className="input-group input-group-lg input-group-solid">
                                        <input
                                            placeholder="john.doe@aes.net"
                                            className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "email")}`}
                                            name="email"
                                            {...formik.getFieldProps("email")}
                                        />
                                    </div>
                                    {formik.touched.email && formik.errors.email ? (
                                        <div className="invalid-feedback display-block">
                                            {formik.errors.email}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleModalClose}>
                            Close
                    </Button>
                        <button
                            type="submit"
                            className="btn btn-success mr-2"
                            disabled={
                                formik.isSubmitting || (formik.touched && !formik.isValid)
                            }
                        >
                            Save
                        {formik.isSubmitting}
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
            <div className="col-lg-12 col-xxl-12">
                <div className={`card card-custom card-stretch gutter-b}`}>
                    <div className="card-header border-0 py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label font-weight-bolder text-dark">
                                Email List for {reportName}
                            </span>
                            <span className="text-muted mt-3 font-weight-bold fz-xs">
                                View and Manage Emails for {reportName}
                            </span>
                        </h3>
                        <div className="card-toolbar">
                            <button
                                onClick={() => setIsModalOpen(true)}
                                className="btn btn-success font-weight-bolder font-size-sm mr-3"
                            >
                                <span className="svg-icon svg-icon-lg svg-icon-white">
                                    <SVG
                                        src={toAbsoluteUrl(
                                            "/media/svg/icons/Code/Plus.svg"
                                        )}
                                    />
                                </span> Add Email
                            </button>
                            <Link
                                to="/management/automated-reports"
                                className="btn btn-danger"
                            >
                                Cancel
                            </Link>
                        </div>
                    </div>
                    <div className="container-fluid">
                        <MUIDataTable
                            data={data}
                            columns={columns}
                            options={{
                                rowsPerPage: 25,
                                rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                                selectableRows: 'none'
                            }}
                        />
                    </div>
                </div>
            </div>
        </div >
    )
}

export default connect(null, { ...alert.actions, ...confirmModal.actions })(AutomatedReportEmailListingPage);